'use client';

import { useAuth } from '@/contexts/AuthProvider';
import { useWorkspace } from '@/contexts/WorkspaceProvider';
import {
  buildHubSpotMarketplaceAuthorizePath,
  HUBSPOT_MARKETPLACE_INSTALL_PATH,
  readPendingHubSpotMarketplaceInstall,
} from '@/lib/hubspot-marketplace-install';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

const DEFERRED_PATH_PREFIXES = [
  '/auth',
  '/complete-profile',
  '/email-verification',
  '/enroll-mfa',
  '/login',
  '/mfa',
  '/onboarding',
  '/sign-up',
];

/**
 * New users may need to finish MFA and workspace onboarding before an install
 * can be bound to a workspace. This narrowly scoped resume hook is inert unless
 * the validated, expiring Marketplace intent key exists in localStorage.
 */
export default function HubSpotMarketplaceInstallResume() {
  const pathname = usePathname();
  const router = useRouter();
  const { isAuthenticated, isSessionInitializing } = useAuth();
  const workspace = useWorkspace();

  useEffect(() => {
    if (isSessionInitializing || !isAuthenticated || !workspace || workspace.isLoading) return;
    if (!workspace.hasWorkspaces || !workspace.activeWorkspace) return;
    if (pathname === HUBSPOT_MARKETPLACE_INSTALL_PATH) return;
    if (DEFERRED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;

    const pending = readPendingHubSpotMarketplaceInstall(window.localStorage);
    if (!pending) return;

    router.replace(buildHubSpotMarketplaceAuthorizePath(pending.returnUrl));
  }, [isAuthenticated, isSessionInitializing, pathname, router, workspace]);

  return null;
}
